import { CampaignFilterType } from './Components/CampaignTypesFilter/CampaignFilterTypes';
import { CampaignStatus } from 'modules/Const';

export const FB_CAMPAIGNS_DEFAULT_AGES = {
  MIN: 24,
  MAX: 35,
}

export const FB_CAMPAIGNS_AGES = {
  MIN: 18,
  MAX: 65,
}

export const FB_CAMPAIGNS_AUTOMATED_AGES = {
  MIN: 18,
  MAX: 35,
}

export const FB_CAMPAIGNS_DEFAULT_LOCAES = [
  { key: 6, name: 'English (US)', selected: true },
  { key: 24, name: 'English (UK)', selected: true }
]

export const FB_CAMPAIGNS_GENDERS = {
  ALL: 'All',
  MALE: 'Male',
  FEMALE: 'Female'
}

export const FB_COMMON_LANGUAGES = [
  { key: 1001, name: 'English (All)', selected: false },
  { key: 24, name: 'English (UK)', selected: false },
  { key: 6, name: 'English (US)', selected: false },
  { key: 1002, name: 'Spanish (All)', selected: false },
]

export type AgeRestrictedCountry = {
  country_code: string,
  name: string,
  age: number
}

export const AGE_RESTRICTED_COUNTRIES: AgeRestrictedCountry[] = [
  { country_code: 'ID', name: 'Indonesia', age: 21 },
  { country_code: 'TH', name: 'Thailand', age: 20 },
]

export const MINIMUM_MEDIA_WIDTH = 500;

export const CUSTOM_AUDIENCES_TOS_URL = 'https://business.facebook.com/customaudiences/app/tos'
export const VALUE_BASED_CUSTOM_AUDIENCES_TOS_URL = 'https://business.facebook.com/customaudiences/value_based/tos';
export const USER_TOS_ACCEPTED_URL = 'https://business.facebook.com/ads/manage/customaudiences/tos';

export type AssetUploadTypes = "upload_video" | "instagram_posts"
export const CreativeAssetTypes: Record<string, AssetUploadTypes> = {
  UPLOAD_VIDEO: 'upload_video',
  INSTAGRAM_POSTS: 'instagram_posts',
}

export const CAMPAIGN_FILTER_LIMIT_DEFAULT = 20

export const CAMPAIGN_FILTER_DEFAULT: CampaignFilterType = {
  campaignTypes: [],
  campaignStatuses: Object.values(CampaignStatus).filter(status => 
    status.toLowerCase() !== 'draft' && status.toLowerCase() !== 'archived'
  ),
  dateModifier: 'all_time',
  startDate: '2024-05-19',
  endDate: '2024-05-26',
  filterDays: '30',
  budgetModifier: 'no_budget_filter',
  budgetAmount1: '',
  budgetAmount2: '',
  limit: CAMPAIGN_FILTER_LIMIT_DEFAULT,
  offset: 0,
  campaignName: '',
  brandIds: []
};